import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_shipment_download_info_by_shipmentId_orderIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number, shipmentId?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LoadContainerSequence?: number, LookupCode?: string, Priority?: number, ReferenceNumber?: string, LoadContainer?: { LookupCode?: string, DockAppointmentsLoadContainersLookup?: { DockAppointmentId?: number, LoadContainerId?: number, DockAppointment?: { Id?: number, LookupCode?: string, ReferenceNumber?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledOn?: string } }[] }, ActualWarehouse?: { Name?: string }, ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, OrderLines?: { OrderId?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number, ShipmentId?: number, StatusId?: number, Material?: { LookupCode?: string, Name?: string } }[] } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId?: number, shipmentId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LoadContainerSequence?: number, LookupCode?: string, Priority?: number, ReferenceNumber?: string, LoadContainer?: { LookupCode?: string, DockAppointmentsLoadContainersLookup?: { DockAppointmentId?: number, LoadContainerId?: number, DockAppointment?: { Id?: number, LookupCode?: string, ReferenceNumber?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledOn?: string } }[] }, ActualWarehouse?: { Name?: string }, ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, OrderLines?: { OrderId?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number, ShipmentId?: number, StatusId?: number, Material?: { LookupCode?: string, Name?: string } }[] } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId?: number, shipmentId?: number, $keys: { OrderId?: number, ShipmentId?: number }[] }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, BrokerReference?: string, ExpectedDate?: string, LoadContainerSequence?: number, LookupCode?: string, Priority?: number, ReferenceNumber?: string, LoadContainer?: { LookupCode?: string, DockAppointmentsLoadContainersLookup?: { DockAppointmentId?: number, LoadContainerId?: number, DockAppointment?: { Id?: number, LookupCode?: string, ReferenceNumber?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledOn?: string } }[] }, ActualWarehouse?: { Name?: string }, ExpectedWarehouse?: { Name?: string } }, Order?: { Id?: number, FulfillmentDate?: string, LookupCode?: string, OrderClassId?: number, OwnerReference?: string, RequestedDeliveryDate?: string, VendorReference?: string, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, OrderLines?: { OrderId?: number, LineNumber?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number, ShipmentId?: number, StatusId?: number, Material?: { LookupCode?: string, Name?: string } }[] } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number, shipmentId?: number    }) {
      return false;
    }
}
